import { createApp } from "vue";
import App from "./App.vue";
import AllComponents from "./components/index";
import AllDirectives from "./directives/index";
import mitt from "mitt";

import { plugin, defaultConfig } from "@formkit/vue";
import { nl } from "@formkit/i18n";

const emitter = mitt();

const app = createApp(App);

app.use(
  plugin,
  defaultConfig({
    // Define additional locales
    locales: { nl },
    // Define the active locale
    locale: "nl",
  })
);
app.provide("emitter", emitter);

AllDirectives.register(app);

AllComponents.register(app); // register all components instead of importing them in component

app.mount("#app");
